import React from 'react';
import { Box } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../i18n/locale-format';
import { SurfaceCard } from '../../components/ui/SurfaceCard';
import { StatusPill } from '../../components/ui/StatusPill';
import { WeekSummary } from './homeStats';

const CHART_HEIGHT = 120;

// Distance-per-day bars; today uses the brand gradient, empty days stay a muted stub.
export const WeekChartCard = ({ week }: { week: WeekSummary }) => {
  const { t } = useTranslation('home');
  const max = Math.max(...week.days.map(d => d.distance), 0);
  const delta = week.previousDistance > 0 ? Math.round(((week.distance - week.previousDistance) / week.previousDistance) * 100) : null;

  return (
    <SurfaceCard
      title={t('weekChart.title')}
      subtitle={t('weekChart.subtitle')}
      action={delta !== null && (
        <StatusPill tone={delta >= 0 ? 'success' : 'danger'} icon={delta >= 0 ? <TrendingUp /> : <TrendingDown />} label={`${delta >= 0 ? '+' : ''}${delta}%`} />
      )}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: { xs: '6px', sm: '10px' }, height: 168, pt: 1 }}>
        {week.days.map(d => {
          const has = d.distance > 0;
          const h = has && max > 0 ? Math.max(4, (d.distance / max) * CHART_HEIGHT) : 4;
          return (
            <Box key={d.date.getTime()} sx={{ flex: 1, minWidth: 0, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
              <Box sx={{ fontSize: 11, color: 'var(--muted)', fontVariantNumeric: 'tabular-nums', minHeight: 14 }}>{has ? d.distance.toFixed(1) : ''}</Box>
              <Box sx={{ width: '100%', maxWidth: 40, borderRadius: '6px', height: h, background: has ? (d.isToday ? 'var(--grad)' : 'var(--bar)') : 'var(--muted-bg)' }} />
              <Box sx={{ fontSize: 12, color: d.isToday ? 'var(--fg)' : 'var(--muted)', fontWeight: d.isToday ? 600 : 400 }}>
                {formatDate(d.date, { weekday: 'narrow' })}
              </Box>
            </Box>
          );
        })}
      </Box>
    </SurfaceCard>
  );
};
